import { render, staticRenderFns } from "./addView.vue?vue&type=template&id=68b6942a&scoped=true"
import script from "./addView.vue?vue&type=script&lang=js"
export * from "./addView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b6942a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68b6942a')) {
      api.createRecord('68b6942a', component.options)
    } else {
      api.reload('68b6942a', component.options)
    }
    module.hot.accept("./addView.vue?vue&type=template&id=68b6942a&scoped=true", function () {
      api.rerender('68b6942a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/baseInfo/hotelInit/addView.vue"
export default component.exports